import styled, { css } from 'styled-components';

import media from '../../../utils/styling/media';

interface StyledBlockProps {
  white?: boolean;
  primary?: boolean;
  nested?: boolean;
  grouped?: boolean;
  padding?: string;
  mdPadding?: string;
}

export const StyledBlock = styled.section<StyledBlockProps>`
  position: relative;
  background: ${({ theme, white, primary, nested }) => {
    if (nested) return theme.colors.gray1;
    if (white) return theme.colors.white;
    if (primary) return theme.colors.primary;

    return theme?.Block?.backgroundColor || theme.colors.smoothGray;
  }};
  padding: ${({ padding, theme }) => padding || theme?.Block?.padding};
  margin-bottom: ${({ grouped }) => grouped ? '' : '16px'};
  border-radius: ${({ theme }) => theme?.Block?.borderRadius};
  box-shadow: ${({ theme }) => theme?.Block?.boxShadow};

  ${media.md<StyledBlockProps>`
    padding: ${({ padding, mdPadding, theme }) => mdPadding || padding || theme?.Block?.mdPadding};
  `}

  &:last-child {
    margin-bottom: 0;
  }

  ${({ primary, theme }) => primary && css`
    color: ${theme.colors.white};
  `}

  ${({ grouped }) => grouped && css`
    box-shadow: none;

    &:not(:first-child) {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &:not(:last-child) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  `}

  ${({ nested }) => nested && css`
    border-top: 1px solid ${({ theme }) => theme.colors.gray4};
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray4};
    padding-top: 36px;
  `}
`;

export const StyledPin = styled.svg`
  position: absolute;
  top: -1px;
  left: calc(50% - 30px);
`;
